export default __webpack_public_path__ + "static/media/Linero2Closed.4ce6702a.jpg";